import { NgModule } from '@angular/core';
import { COMMON_MODULES } from '../../constants/common-modules';
import { ParkingFormComponent } from './parking-form.component';

@NgModule({
  declarations: [ParkingFormComponent],
  imports: [...COMMON_MODULES],
  exports: [ParkingFormComponent],
})
export class ParkingFormModule {}
